import React, { useState, useEffect, useCallback } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DataTable from '../../../shared/tables/DataTable';
import CustomPagination from '../../../shared/pagination/CustomPagination';
import { AVAILABILITY_COLUMNS, AVAILABILITY_TABLE_NAME, STORE_HOURS_TODAY_ARE_FROM, REGULAR_HOURS } from '../../../constants/storesPageConstants';
import { Paper, Typography, Box, Grid, TextField, Breadcrumbs, Link} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { useSelector, useDispatch } from 'react-redux';
import { singleStoreDetailsSaga, selectedStoreSelectorSaga } from '../../../redux/saga/storePageSelectors';
import { Link as RouterLink, useParams } from 'react-router-dom';
import storeIcon from '../../../../public/assets/img/storeIcon.svg';
import './SingleStoreView.scss';
import { handleSortingInTable, convertTo12HourFormat } from '../../../shared/utils/format.helpers';
import { STORE_NAME, BANK_ACCOUNT_DETAILS, PAYOUT_FREQUENCY, WEEKLY, WEEKLY_PAYOUT_TEXT1, WEEKLY_PAYOUT_TEXT2, BANKING_ACCOUNT_HOLDER_NUMBER, BANKING_ACCOUNT_ROUTING_NUMBER, BANKING_ROUTING_NUMBER, BANKING_BANK_ACCOUNT_NUMBER, BANKING_REENTER_ACCOUNT_NUMBER, BANKING_BUSINESS_LEGAL_ENTITY_NAME, BANKING_ADDRESS, BANKING_CITY, BANKING_STATE, BANKING_ZIP, SETTINGS_STORE_DETAILS,SETTINGS_ORDER_SETTINGS, SETTINGS_STORE_PHOTOS, SETTINGS_LOGO, SETTINGS_HEADER, SETTINGS_NAME, SETTINGS_PHONE_NUMBER, SETTINGS_ADDRESS,SETTINGS_WEBSITE, SETTINGS_CUISINE_TYPE, DEFAULT_TELEPHONE_NUMBER, SETTINGS_DRIVER_PICKUP_INSTRUCTIONS, SETTINGS_STORE_PHOTOS_SUBTITLE, SETTINGS_PICKUP_CONFIGURE, SETTINGS_INSTRUCTIONS, SETTINGS_NONE, SETTINGS_ENABLED, SETTINGS_NOT_SET_UP, NOT_AVAILABLE, STORES, AVAILABILITY, SETTINGS, BANKING } from '../../../constants/storesPageConstants';
import { formatPhoneNumber } from '../../../shared/utils/format.helpers';
import IMAGE_PLACEHOLDER from '../../../../public/assets/img/placeHolder.png';
import { getSingleStoreDetailsRequest } from '../../../redux/actions/storeActions';
import { useMerchant } from '../../../MerchantContext';
import { accessTokenSaga } from '../../../redux/saga/loginServiceSelector';
import { trackTabView_Mixpanel } from '../../../shared/mixpanel/mixpanel';

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	return (
		<div
		role='tabpanel'
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
		{...other}
		>
		{value === index && (
			<Box sx={{ p: 3 }}>
			{children}
			</Box>
		)}
		</div>
	);
}

const trackTabView = (tabValue) => {
	let tabName;
	switch(tabValue) {
	  case 0:
		tabName = AVAILABILITY;
		break;
	  case 1:
		tabName = SETTINGS;
		break;
	  case 2:
		tabName = BANKING;
		break;
	  default:
		tabName = AVAILABILITY;
	}
	trackTabView_Mixpanel(tabName, 'single store view');
};

const SingleStoreView = () => {

	const dispatch = useDispatch();
	const singleStoreDetails = useSelector(singleStoreDetailsSaga);
	//console.log(singleStoreDetails);
	const selectedStoreSelector = useSelector(selectedStoreSelectorSaga);
	//const singleStoreDetails = {
    //  storeId: '96038',
    //  storeName: 'Pardon My Cheesesteak',
    //  storeStatus: 'Accepting orders until 11:00 PM',
	//  streetAddress: '3200 hackberry rd, Irving, tx 75039',
	//  telephone: '9039119223',
	//  website: 'www.test.com',
	//  isDisabled:false,
	//  isOffline:false,
    //  allHours: {
    //    baseHours: { period: [
	//		{day:'Sunday', endDay:'Sunday', from:'07:00', to:'23:00', type:'pickup'},
	//		{day:'Monday', endDay:'Monday', from:'07:00', to:'23:00', type:'pickup'},
	//		{day:'Tuesday', endDay:'Tuesday', from:'07:00', to:'23:00', type:'pickup'},
	//		{day:'Wednesday', endDay:'Wednesday', from:'07:00', to:'23:00', type:'pickup'},
	//		{day:'Thursday', endDay:'Thursday', from:'07:00', to:'23:00', type:'pickup'},
	//		{day:'Friday', endDay:'Friday', from:'07:00', to:'23:00', type:'pickup'},
	//		{day:'Saturday', endDay:'Saturday', from:'07:00', to:'23:00', type:'pickup'},
	//	] },
    //    overrideHours: { datePeriod: [
	//		{date: '2024-01-01T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-02T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-03T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-04T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-05T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-06T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-07T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-08T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-09T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-20T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-21T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-22T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-23T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},
	//		{date: '2024-01-24T00:00:00.000+00:00', from: '00:00', to:'01:30', type:'pickup'},

	//	] }
    //  }
    //};

	const [tabValue, setTabValue] = useState(0);
	const [storeHours, setStoreHours] = useState([]);
	const [storeStatus, setStoreStatus] = useState('');
	const [todayHours, setTodayHours] = useState('');
	const [ specialHours, setSpecialHours ] = useState([]);
	const [ storeReopenTimeText, setStoreReopenTimeText ] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalPages, setTotalPages] = useState(0);
	const [showBreadCrumb, setShowBreadCrumb] = useState(true);
	const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'Descending' });
	const accessToken = useSelector(accessTokenSaga);
	const { merchantId, setMerchantId } = useMerchant();
	const { storeUUID } = useParams();

	useEffect(()=>{
		if (selectedStoreSelector?.storeId && selectedStoreSelector?.storeUUID) {
			setShowBreadCrumb(false);
		}
		if (singleStoreDetails.length == 0 && accessToken) {
			dispatch(getSingleStoreDetailsRequest(merchantId, storeUUID ));
		}
		trackTabView(tabValue);
	},[]);
	useEffect(()=>{
		if (singleStoreDetails.length == 0 && accessToken) {
			dispatch(getSingleStoreDetailsRequest(merchantId, storeUUID ));
		}
	},[accessToken]);

	const sortData = (data, { key, direction }) => {
		// Create a shallow copy of the data before sorting
		const dataToSort = [...data];
		return dataToSort.sort((a, b) => {
		  if (a[key] < b[key]) return direction === 'Ascending' ? -1 : 1;
		  if (a[key] > b[key]) return direction === 'Ascending' ? 1 : -1;
		  return 0;
		});
	};
	  
	const sortedAndFilteredData = sortData(specialHours, sortConfig);
	//console.log('sortedAndFilteredData', sortedAndFilteredData);
	const indexOfLastRow = (currentPage + 1) * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage;
	const updatedSpecialHours = sortedAndFilteredData.slice(indexOfFirstRow, indexOfLastRow);
	//console.log('updatedSpecialHours', updatedSpecialHours);

	useEffect(() => {
		const newTotalPages = Math.ceil(updatedSpecialHours.length / rowsPerPage);
		setTotalPages(newTotalPages);
	}, [updatedSpecialHours, rowsPerPage]);

	const handleSpecialHoursSort = (columnKey) => {
		handleSortingInTable(columnKey, sortConfig, setSortConfig );
	};
	const onPageChange = (newPage) => {
		setCurrentPage(newPage);
	  };
	const onRowsPerPageChange = (newRowsPerPage) => {
		setRowsPerPage(newRowsPerPage);
		setCurrentPage(0);
	};

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue);
		trackTabView(newValue);
	};

	const handleBreadCrumbClick = (event) => {
		event.preventDefault();
	}

	const getStatusColor = useCallback((details) => {
		const status = details?.storeStatus || '';
		if (details?.isDisabled === true && details?.isOffline === true) {
			return { color: 'grey', text: 'CLOSED' };
		} else if (details?.isDisabled === true && details?.isOffline === false) {
			return { color: 'grey', text: 'CLOSED' };
		} else if (details?.isDisabled === false && details?.isOffline === true) {
		  return { color: 'red', text: 'PAUSED' };
		} else if (details?.isDisabled === false && details?.isOffline === false && status.includes('Accepting')) {
				return { color: '#007350', text: 'OPEN' };
		} else if (details?.isDisabled === false && details?.isOffline === false && status.includes('closed')) {
				return { color: 'red', text: 'CLOSED' };
		} else return { color: 'red', text: 'STATUS NOT AVAILABLE' };
	  }, []);
	  

	useEffect(() => {
		if (singleStoreDetails) {
		  const baseHoursPeriod = singleStoreDetails?.allHours?.baseHours?.period;
		  const specialHoursPeriod = singleStoreDetails?.allHours?.overrideHours?.datePeriod;
		  if (specialHoursPeriod) {
			const filteredAndEnhancedSpecialHours = specialHoursPeriod
				.filter(hour => hour.type === 'pickup')
				.map(hour => {
					const datePortion = hour.date.split('T')[0];
					const date = new Date(datePortion);
					const formattedDate = date.toLocaleDateString('en-US', {
						timeZone: 'UTC',
						weekday: 'short',
						month: 'short',
						day: 'numeric'
					});
					const formattedFrom = convertTo12HourFormat(hour.from);
					const formattedTo = convertTo12HourFormat(hour.to);
		
					return {
						...hour,
						date: formattedDate,
						hours: `${formattedFrom} to ${formattedTo}`,
						name: 'Special Hours'
					};
				});
			setSpecialHours(filteredAndEnhancedSpecialHours);
		  }
		  if (baseHoursPeriod) {
			const daysOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
			const pickupPeriods = baseHoursPeriod.filter(period => period.type === 'pickup');
			const sortedStoreHours = pickupPeriods.map((period, index) => ({
			  day: period.day,
			  hours: `${convertTo12HourFormat(period.from)} - ${convertTo12HourFormat(period.to)}`,
			  type: period.type,
			  id: index + 1
			})).sort((a, b) => daysOrder.indexOf(a.day) - daysOrder.indexOf(b.day));
			setStoreHours(sortedStoreHours);
		  }
		  const status = getStatusColor(singleStoreDetails);
		  	setStoreStatus(status);
	  
		}
	}, [singleStoreDetails, getStatusColor]);


	useEffect(() => {
		const daysOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		const today = new Date();
		const dayName = daysOrder[today.getDay()];
		const todayStoreHours = storeHours.find(entry => entry.day === dayName);
		if (todayStoreHours) {
			setTodayHours(todayStoreHours.hours);
		} else {
			setTodayHours('Not available');
		}
		const tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		const tomorrowName = daysOrder[tomorrow.getDay()];
		const tomorrowHours = storeHours.find(entry => entry.day === tomorrowName);
		if (storeStatus.text === 'CLOSED' && tomorrowHours) {
			const startTime = tomorrowHours.hours.split(' - ')[0];
			const text = `Your store is currently closed and will reopen at ${startTime} tomorrow.`;
			setStoreReopenTimeText(text);
		}
	}, [storeHours, storeStatus, singleStoreDetails]);

	//console.log('singleStoreDetails: ',singleStoreDetails);
    
  return (
    <>
		<>
		{showBreadCrumb && (
			<div role='presentation' onClick={handleBreadCrumbClick} className='breadCrumb'>
				<Breadcrumbs aria-label='breadcrumb'>
					<Link component={RouterLink} to='/dashboard/stores' className='breadCrumb-home'>
						{STORES}
					</Link>
					<Typography color='text.primary' className='breadCrumb-link'>{singleStoreDetails.storeName ? `${singleStoreDetails.storeName} (${singleStoreDetails.storeId})` : STORE_NAME } </Typography>
				</Breadcrumbs>
			</div>
		)}
		<div className='store-availability-container'>
			<Paper className='store-availability-container--page-header'>
				<h4 className='store-availability-container--title' data-testid='store-availability-title'>{singleStoreDetails.storeName ? `${singleStoreDetails.storeName} (${singleStoreDetails.storeId})` : STORE_NAME }</h4>
			</Paper>
		</div>

		<Paper square>
			<Tabs
			value={tabValue}
			indicatorColor='secondary'
			textColor='inherit'
			onChange={handleTabChange}
			sx={{
				'.Mui-selected': { color: '#111111', fontWeight: '700', fontFamily: 'Basis Grotesque Pro' },
				'.MuiTabs-indicator': { backgroundColor: '#007350', height: '4px', borderRadius:'4px', fontFamily: 'Basis Grotesque Pro' },
			  }}
			>
				<Tab label='Availability' sx={{textTransform: 'none', color: '#767676'}} data-testid='availability-tab'/>
				<Tab label='Settings' sx={{textTransform: 'none', color: '#767676'}} data-testid='settings-tab'/>
				<Tab label='Banking' sx={{textTransform: 'none', color: '#767676'}} data-testid='banking-tab'/>
			</Tabs>
      	</Paper>

		<TabPanel value={tabValue} index={0}>
			<div className='availability-container'>
				<Box sx={{ flexGrow: 1}} className='marginBottom16'>
					<Grid container spacing={2} alignItems='stretch'>
						<Grid item xs={12} sm={7}>
						<Paper elevation={1} className='topContainer-availability defaultCardContainerBorder'>
							<Box className='fullHeight'>
								<Typography variant='h6' gutterBottom  className='tableHeader'>
									{singleStoreDetails.storeName ? `${singleStoreDetails.storeName} (${singleStoreDetails.storeId})` : STORE_NAME }
								</Typography>
								<Box className='currentStoreHours'>
									<Typography variant='body2' className='text-align-left'>
										{storeReopenTimeText}
									</Typography>
								</Box>
								<Typography variant='subtitle1' gutterBottom className='storeStatus'>
									{storeStatus.text}
									<CircleIcon sx={{ color: storeStatus.color , mr: 1}}  className='circleIcon'/>
								</Typography>
							</Box>
							<Typography variant='body2' className='storeHoursParent text-align-left'>
								<Box component='span' className='storeHours'>
									<img src={storeIcon} className='imageStoreIcon' alt='Store Icon' />
									{STORE_HOURS_TODAY_ARE_FROM} {todayHours}.
								</Box>
							</Typography>
						</Paper>
						</Grid>

						<Grid item xs={12} sm={5}>
						<Paper elevation={1} className='regularHoursBlock defaultCardContainerBorder'>
							<Typography variant='h6' gutterBottom className='tableHeader'>
			  					{REGULAR_HOURS}
							</Typography>
							<Box className='regularHoursParentContainer'>
							{storeHours.map((item, index) => (
								<Box key={item.id} className='regularHoursContainer'>
								<Typography variant='body2'>{item.day}</Typography>
								<Typography variant='body2'>{item.hours}</Typography>
								</Box>
							))}
							</Box>
						</Paper>
						</Grid>
					</Grid>
				</Box>
				<div className='dataTable'>
					<DataTable
						data={updatedSpecialHours}
						columns={AVAILABILITY_COLUMNS}
						tableName={AVAILABILITY_TABLE_NAME}
						tableSubTitle=''
						showTableFilter= {false}
						includeCheckbox= {false}
						showAddToList={false}
						onSort={handleSpecialHoursSort}
						sortConfig={sortConfig}
						hideSearchIfOneStoreSelected={false}
						noResultsText='No Special Hours Found'
					/>
					<CustomPagination
						totalNumberOfPages={totalPages}
						currentPageNumber={currentPage}
						rowsPerPage={rowsPerPage}
						onPageChange={(event, newPage) => onPageChange(newPage)}
						onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
						rowsPerPageOptions={[10,20,50]}
					/>
				</div>
			</div>
      	</TabPanel>
		</>

		<TabPanel value={tabValue} index={1}>
			<div className='settings-container'>
				<Box sx={{ flexGrow: 1}} className='marginBottom16'>
					<Grid container spacing={2} alignItems='stretch'>
						<Grid item xs={12}>
						<Paper elevation={1} className='topContainer-settings marginBottom16 defaultCardContainerBorder'>
							<Box className='fullHeight'>
								<Typography variant='h6' gutterBottom  className='tableHeader'>
									{SETTINGS_STORE_DETAILS}
								</Typography>
								<Grid container alignItems='flex-start' spacing={2} className='padding16'>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
										{SETTINGS_NAME}
										</Typography>
										<Typography className='sideHeader-content'>{singleStoreDetails.storeName || NOT_AVAILABLE}</Typography>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{SETTINGS_PHONE_NUMBER}
										</Typography>
										<Typography className='sideHeader-content'>{formatPhoneNumber(singleStoreDetails?.telephone ) || DEFAULT_TELEPHONE_NUMBER}</Typography>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{SETTINGS_ADDRESS}
										</Typography>
										<Typography className='sideHeader-content'>
											{singleStoreDetails.streetAddress && singleStoreDetails.city && singleStoreDetails.state && singleStoreDetails.zip? `${singleStoreDetails.streetAddress}, ${singleStoreDetails.city}, ${singleStoreDetails.state} ${singleStoreDetails.zip}`: NOT_AVAILABLE}
											</Typography>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{SETTINGS_WEBSITE}
										</Typography>
										<Typography className='sideHeader-content'>{singleStoreDetails.website || NOT_AVAILABLE}</Typography>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{SETTINGS_CUISINE_TYPE}
										</Typography>
										<Typography className='sideHeader-content'>{singleStoreDetails.cuisineType || NOT_AVAILABLE }</Typography>
									</Grid>
								</Grid>
							</Box>
						</Paper>
						<Paper elevation={1} className='topContainer-settings marginBottom16 defaultCardContainerBorder'>
							<Box className='fullHeight'>
								<Typography variant='h6' gutterBottom  className='tableHeader'>
									{SETTINGS_ORDER_SETTINGS}
								</Typography>
								<Grid container alignItems='flex-start' spacing={2} className='padding16'>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
										{SETTINGS_DRIVER_PICKUP_INSTRUCTIONS}
										</Typography>
										<Typography className='pickup-notes marginBottom16'>{SETTINGS_INSTRUCTIONS}: {singleStoreDetails.pickUpNotes || SETTINGS_NONE }</Typography>
										<Typography className='pickup-notes'>{SETTINGS_PICKUP_CONFIGURE}</Typography>
									</Grid>
									<Grid item xs={12} sm={6}>
										{singleStoreDetails.pickUpNotes ? (
										<Typography className='sideHeader-content pickup-status'>
											<span className='enabled-text'>{SETTINGS_ENABLED}</span>
										</Typography>
										):(
										<Typography className='sideHeader-content pickup-status'>
											<span className='disabled-text'>{SETTINGS_NOT_SET_UP}</span>
										</Typography>
										)}
									</Grid>
								</Grid>
							</Box>
						</Paper>
						<Paper elevation={1} className='topContainer-settings defaultCardContainerBorder'>
							<Box className='fullHeight'>
								<Typography variant='h6' gutterBottom  className='tableHeader'>
									{SETTINGS_STORE_PHOTOS}
									<Typography gutterBottom className='tableSubHeader'>
										{SETTINGS_STORE_PHOTOS_SUBTITLE}
									</Typography>
								</Typography>
								
								<Grid container alignItems='flex-start' spacing={2} className='padding16'>
									<Grid item xs={12} sm={6}>
										<Typography className='picture-header' >{SETTINGS_LOGO}</Typography>
										<img src={(singleStoreDetails.logo && singleStoreDetails.logo !== 'null') ? singleStoreDetails.logo : IMAGE_PLACEHOLDER } className='image-width' alt='store-logo'/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography className='picture-header' >{SETTINGS_HEADER}</Typography>
										<img src={(singleStoreDetails.header && singleStoreDetails.header !== 'null') ? singleStoreDetails.header : IMAGE_PLACEHOLDER } className='image-width' alt='store-header-logo'/>
									</Grid>
								</Grid>
							</Box>
						</Paper>
						</Grid>
					</Grid>
				</Box>
			</div>
		</TabPanel>

		<TabPanel value={tabValue} index={2}>
			<div className='banking-container'>
				<Box sx={{ flexGrow: 1}} className='marginBottom16'>
					<Grid container spacing={2} alignItems='stretch'>
						<Grid item xs={12} sm={9}>
							<Paper elevation={1} className='topContainer-availability defaultCardContainerBorder'>
								<Box className='fullHeight'>
									<Typography variant='h6' gutterBottom  className='tableHeader'>
										{BANK_ACCOUNT_DETAILS}
									</Typography>
								</Box>
								<Grid container alignItems='flex-start' spacing={2} className='padding16'>
									{/*<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_ACCOUNT_HOLDER_NAME}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_ACCOUNT_HOLDER_NAME}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.storeName || BANKING_ACCOUNT_HOLDER_NAME}
										/>
									</Grid>*/}
									{/*<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_ROUTING_NUMBER}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_ROUTING_NUMBER}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={BANKING_ACCOUNT_ROUTING_NUMBER}
										/>
									</Grid>*/}
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_BANK_ACCOUNT_NUMBER}
										</Typography>
										{/*update the account number here if there are any new changes*/}
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_BANK_ACCOUNT_NUMBER}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.connectedAccountId || BANKING_ACCOUNT_HOLDER_NUMBER}
										/>
									</Grid>
									{/*<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_REENTER_ACCOUNT_NUMBER}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_REENTER_ACCOUNT_NUMBER}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.connectedAccountId || BANKING_ACCOUNT_HOLDER_NUMBER}
										/>
									</Grid>*/}
									{/*<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_BUSINESS_LEGAL_ENTITY_NAME}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_BUSINESS_LEGAL_ENTITY_NAME}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.accountProvider || BANKING_BUSINESS_LEGAL_ENTITY_NAME}
										/>
									</Grid>*/}
									{/*<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_ADDRESS}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_ADDRESS}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.streetAddress || BANKING_ADDRESS}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_CITY}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_CITY}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.city || BANKING_CITY}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' gutterBottom className='defaultFont sideHeader' align='left'>
											{BANKING_STATE}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_STATE}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.state || BANKING_STATE}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant='caption' display='block' className='defaultFont sideHeader' gutterBottom align='left'>
											{BANKING_ZIP}
										</Typography>
										<TextField
											fullWidth
											disabled
											placeholder={BANKING_ZIP}
											variant='outlined'
											className='text-background'
											InputLabelProps={{ shrink: true }}
											value={singleStoreDetails.zip || BANKING_ZIP}
										/>
									</Grid>*/}
								</Grid>
							</Paper>
						</Grid>

						<Grid item xs={12} sm={3}>
							<Paper elevation={1} className='payoutFreqBlock defaultCardContainerBorder'>
								<Typography variant='h6' gutterBottom className='tableHeader'>
									{PAYOUT_FREQUENCY}
								</Typography>
								<Box className='payoutFrequencyParentContainer'>
									<Box className='payoutFrequencyContainer'>
										<Typography variant='body2' className='marginBottom16 frequencyText' sx={{fontWeight: 600}}>{singleStoreDetails.payoutFrequency || WEEKLY}</Typography>
										<Typography variant='body2' className='weekly-payout-text'>{WEEKLY_PAYOUT_TEXT1} {singleStoreDetails.payoutFrequency || WEEKLY} {WEEKLY_PAYOUT_TEXT2}</Typography>
									</Box>
								</Box>
							</Paper>
						</Grid>
					</Grid>
				</Box>
			</div>
		</TabPanel>
	</>
  );
}

export default SingleStoreView;
